import { Link } from "@mui/material";
import { SONL_LINK } from "@covertree/consts";

export const SONLLink = (
  <Link
    href={SONL_LINK}
    target="_blank"
    underline="hover"
    rel="noopener noreferrer">
    No-Loss-Statement.pdf
  </Link>
);
